<template>
  <div class="view view-offset view-contact">
    <div class="content-align-center" v-html="content[language]" />
    <stores :language="language" />
  </div>
</template>

<script>
import Stores from '@/components/Stores'

export default {
  name: 'view-contact',
  components: { Stores },
  props: {
    language: String
  },
  data: () => ({
    content: {
      de: '<h1>Kontakt</h1>',
      en: '<h1>Contact</h1>'
    }
  })
}
</script>
